import React from 'react';
import './subscription.scss';
import { connect } from 'react-redux';
import SectionDivider from '../SectionDivider';
import {
  resetSelectedSlot,
  setSubscriptionSlot,
} from 'hb-redux-store/feature/subscription/subscription.action';
import { setAppNotification } from 'hb-redux-store/initial.action';

const SlotPicker = props => {
  const { subscriptionId, calendar, setSubscriptionSlot, launchInfo } = props;
  const { selectedSlot } = props;
  const [hasDeliverySlot, setDeliverySlot] = React.useState(selectedSlot);
  const isLoggedInUser = launchInfo.loggedIn;
  const [slots, setSlots] = React.useState(calendar.timeSlots);
  const successCb = slot => {
    setDeliverySlot(slot);
    setSlots(slots.map(s => ({ ...s, isSelected: s.slotId === slot.slotId })));
  };
  const failCb = err => {};
  const setSlot = slot => {
    if (!isLoggedInUser) {
      return props.setAppNotification('Please login to subscribe.');
    }
    setSubscriptionSlot({
      slot: { ...slot, subscriptionId },
      successCb,
      failCb,
    });
  };
  return (
    <React.Fragment>
      <div className="subsc--pane">
        <div className="subsc--pane--title">
          <span className="subsc--pane--title--number">1</span>
          <span>
            Select a Delivery Time Slot
            <div className="subsc--pane--subtitle">
              Selected time slot will be applicable to all the days
            </div>
          </span>
        </div>
        <div className="subsc--pane--content">
          <div className="subsc--slots">
            {!hasDeliverySlot &&
              slots?.map(s => (
                <div
                  className="subsc--slots--slot"
                  key={s.slotId}
                  onClick={() => setSlot(s)}
                >
                  {s.title}
                </div>
              ))}
            {hasDeliverySlot && (
              <div className="">
                <div className="subsc--slots--slot selected">
                  {selectedSlot.title}
                </div>
                <span
                  className="subsc--slots--change"
                  onClick={() => {
                    setDeliverySlot(false);
                    props.resetSelectedSlot();
                  }}
                >
                  Change
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <SectionDivider />
    </React.Fragment>
  );
};

const mapStatetoProps = ({ subscriptionReducer, initialReducer }) => ({
  calendar: subscriptionReducer.calendar,
  subscriptionId: subscriptionReducer.subscriptionId,
  selectedSlot: subscriptionReducer.selectedSlot,
  loading: subscriptionReducer.loading,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  setSubscriptionSlot,
  setAppNotification,
  resetSelectedSlot,
};

export default connect(mapStatetoProps, mapDispatchToProps)(SlotPicker);
